export default __webpack_public_path__ + "static/self_desktop-02fad64fc7c6630b92ad5bc95480af3a.mp4";